import { myAccountLink } from "component-library";

export const navigateToHomePage = () => {
  const url = myAccountLink.endsWith("/")
    ? myAccountLink.slice(0, -1)
    : myAccountLink;
  window.location.assign(url);
};
